import {InitStartResponse} from "../http/nj-booking";

const SETTINGS_STORE_KEY = "nj-booking-settings";

export class SessionService {

	private static _instance: SessionService;

	private settings: InitStartResponse;

	static get instance(): SessionService {
		if (!this._instance) {
			this._instance = new SessionService();
		}
		return this._instance;
	}

	private constructor() {
		this.settings = this.loadSettings();
	}

	private loadSettings(): InitStartResponse {
		const data = sessionStorage.getItem(SETTINGS_STORE_KEY);
		if (!data) {
			return null;
		}

		try {
			return JSON.parse(data);
		} catch (e) {
			console.error("Failed to restore stored settings: ", e);
			return null;
		}
	}

	private storeSettings() {
		sessionStorage.setItem(SETTINGS_STORE_KEY, JSON.stringify(this.settings));
	}

	setStartData(settings: InitStartResponse) {
		this.settings = settings;
		this.storeSettings();
	}

	resetSession() {
		this.settings.publicId = null;
		this.settings.token = null;
		this.storeSettings();
	}

	isDebug() {
		return this.settings?.debug;
	}

	getI18nData() {
		return this.settings?.i18nData;
	}

	getPublicId() {
		return this.settings?.publicId;
	}

	getToken() {
		return this.settings?.token;
	}

	getTicketUrl() {
		return this.settings?.ticketUrl;
	}

	getBookingUrl() {
		return this.settings?.bookingUrl;
	}

	getMagnoliaBaseUrl() {
		return this.settings?.magnoliaBaseUrl;
	}

	getEnabledPaymentMethods() {
		return this.settings?.enabledPaymentMethods;
	}

	useAgbCheckbox() {
		return this.settings?.useAgbCheckbox;
	}

	isErvEnabled() {
		return this.settings?.ervEnabled;
	}
}
